import logo from '@/assets/gbwhatspro-chat/01-logo-transparent.webp'
import heroIcon from '@/assets/gbwhatspro-chat/03-hero-3d-app-icon.webp'
import latestVersionImg from '@/assets/gbwhatspro-chat/06-latest-version-section.webp'

const domain = 'https://gbwhatspro.chat'

export const apkMeta = {
	version: 'v18.80',
	size: '78 MB',
	android: 'Android 5.0+',
	updated: 'June 2026',
}

export const contactEmail = process.env.VUE_APP_CONTACT_EMAIL || 'support@gbwhatspro.chat'

const makeMeta = (title, description, keywords, path) => ({
	appname: 'GB WhatsApp Pro',
	title,
	keywords,
	description,
	link: [
		{
			rel: 'canonical',
			href: `${domain}${path}`,
		},
	],
})

export const apkRequest = {
	domain: 'gbwhatspro.chat',
	appName: 'GB_gbwhatspro.chat',
}

export const navItems = [
	{ label: 'Home', path: '/' },
	{ label: 'Download', path: '/download/' },
	{ label: 'For PC', path: '/gb-whatsapp-pro-for-pc/' },
	{ label: 'For iPhone', path: '/gb-whatsapp-pro-for-ios/' },
	{ label: 'Old Version', path: '/gb-whatsapp-pro-old-version/' },
]

export const footerItems = [
	{ label: 'Privacy Policy', path: '/privacy-policy/' },
	{ label: 'Terms & Conditions', path: '/terms-and-conditions/' },
	{ label: 'Disclaimer', path: '/disclaimer/' },
	{ label: 'Contact Us', path: '/contact/' },
]

const homeSections = [
	{
		title: 'What is GB WhatsApp Pro?',
		paragraphs: [
			'[GB WhatsApp Pro](/) is a modified version of the original WhatsApp application designed to provide users with enhanced features that are not available in the official app. It is built on the same messaging foundation but offers more customization, privacy control, and flexibility.',
			'Unlike the standard WhatsApp, GB WhatsApp Pro is not available on the Google Play Store. Instead, it is distributed as an APK file and installed manually on Android devices. Users typically choose this version when they want more control over their messaging experience, such as hiding online status, sending larger files, or using multiple accounts.',
		],
	},
	{
		title: 'Why Do People Use GB WhatsApp Pro?',
		paragraphs: [
			'Many users prefer GB WhatsApp Pro because it removes several limitations found in the official WhatsApp. The main reason is flexibility.',
		],
		split: {
			left: {
				subtitle: 'People use it to',
				list: [
					'Customize their chat interface',
					'Hide last seen, blue ticks, and typing status',
					'Send larger videos and images',
					'Use dual WhatsApp accounts on one device',
					'Access additional privacy settings',
				],
				after: ['In short, it is popular among users who want more control over their messaging experience beyond what the official app allows.'],
			},
			right: {
				subtitle: 'User Feedback',
				feedback: [
					{ text: 'I like GB WhatsApp because I can hide my online status and use two accounts on one phone. It feels much more flexible than normal WhatsApp.', author: 'User', location: 'India', flag: '🇮🇳' },
					{ text: 'La fonction de confidentialité est incroyable. Je peux cacher les coches bleues et lire les messages sans être vu.', author: 'Utilisateur', location: 'France', flag: '🇫🇷' },
					{ text: 'Me gusta porque puedo enviar videos grandes y personalizar todo el chat.', author: 'Usuario', location: 'Mexico', flag: '🇲🇽' },
					{ text: 'The dual account feature is the main reason I use it. Very convenient for work and personal use.', author: 'User', location: 'Singapore', flag: '🇸🇬' },
				],
			},
		},
	},
	{
		title: 'Key Features of GB WhatsApp Pro',
		paragraphs: [
			'GB WhatsApp comes with a wide range of enhanced features designed to improve usability, privacy, and personalization. Each feature is built to give users more control compared to the official WhatsApp.',
		],
		cards: [
			{ icon: 'privacy', title: 'Advanced Privacy Controls', text: 'Hide online status, last seen, blue ticks, second ticks, and typing/recording indicators. You can read messages without letting others know.' },
			{ icon: 'themes', title: 'Custom Themes & UI Personalization', text: 'Change the entire look of your WhatsApp interface with thousands of themes, fonts, and chat styles. Fully customize colors and layouts.' },
			{ icon: 'anti-delete', title: 'Anti-Delete Messages', text: 'Even if someone deletes a message, you can still view it. This includes text, images, and voice messages.' },
			{ icon: 'media', title: 'Extended Media Sharing', text: 'Send larger files without compression:', list: ['Videos up to high size limits', 'High-quality images without loss', 'Large documents and audio files'] },
			{ icon: 'lock', title: 'Built-in App Lock', text: 'Protect your chats using:', list: ['PIN lock', 'Pattern lock', 'Fingerprint lock'], after: 'No need for third-party apps.' },
			{ icon: 'dnd', title: 'DND Mode (Do Not Disturb)', text: 'Disable WhatsApp internet access while keeping other apps online. Perfect for focus, gaming, or work.' },
			{ icon: 'accounts', title: 'Multiple Accounts Support', text: 'Use two WhatsApp accounts on the same device without cloning apps. Easily switch between personal and work accounts.' },
			{ icon: 'auto-reply', title: 'Auto Reply System', text: "Set automatic replies for incoming messages. Useful for business accounts or when you're busy." },
			{ icon: 'scheduler', title: 'Message Scheduler', text: 'Schedule messages to be sent at a specific time. Never forget birthdays, reminders, or important messages.' },
			{ icon: 'hidden', title: 'Hidden Media & Privacy Folder', text: 'Hide specific chats, media files, or conversations inside a private section accessible only by you.' },
			{ icon: 'status', title: 'Status Download Feature', text: "Download friends' WhatsApp status (images/videos) directly without external tools." },
			{ icon: 'controls', title: 'Extra Custom Controls', list: ['Disable forward tag', 'Freeze last seen', 'Hide view status', 'Customize ticks style'] },
		],
	},
	{
		title: "What's New in the Latest Version of GB WhatsApp Pro?",
		mediaLayout: 'split',
		paragraphs: [
			'The latest version of GBWhatsApp Pro is v18.80, released in June 2026. This update focuses on improving performance stability, strengthening anti-ban protection, and enhancing overall user experience. It is currently one of the most stable builds available for Android users who prefer advanced WhatsApp features.',
			'In this update, users can expect smoother performance, fewer crashes, and improved compatibility with newer Android devices. The interface has also been slightly optimized for better navigation and faster loading speed.',
		],
		subtitle: 'New in v18.80:',
		list: [
			'Latest Version: v18.80',
			'Release Date: June 2026',
			'Improved Anti-Ban Protection System',
			'Faster message sending and app response time',
			'More stable custom themes engine',
			'Better media sharing performance (images, videos, documents)',
			'Bug fixes from previous versions (lag & crash reduction)',
			'Improved compatibility with Android 5.0+ devices',
		],
		after: ['This update also improves background performance, making the app more stable even when running multiple accounts or heavy media usage.'],
		image: latestVersionImg,
		imageAlt: 'GB WhatsApp Pro latest version chat interface preview',
	},
	{
		title: 'How to Download GB WhatsApp Pro APK',
		paragraphs: [
			'To download [GB WhatsApp Pro APK](/), users must rely on external sources since it is not available on official app stores.',
		],
		subtitle: 'Steps:',
		orderedLayout: 'arrow-flow',
		ordered: [
			'Visit a trusted website that offers the latest APK version',
			'Find the "Download APK Latest Version" button',
			'Tap to start downloading the file',
			'Wait for the download to complete',
			'Locate the file in your Downloads folder',
		],
		after: ['Always ensure you are downloading the latest stable version to avoid compatibility issues or security risks.'],
		cta: 'Download APK',
	},
	{
		title: 'How to Install GB WhatsApp Pro on Android',
		paragraphs: ['Installing GB WhatsApp Pro APK is simple if you follow the correct steps:'],
		stepsLayout: 'timeline',
		steps: [
			{ title: 'Step 1: Enable Unknown Sources', text: 'Go to Settings → Security → Enable "Install Unknown Apps"' },
			{ title: 'Step 2: Locate APK File', text: 'Open File Manager and find the downloaded APK file' },
			{ title: 'Step 3: Install the App', text: 'Tap the file and select Install' },
			{ title: 'Step 4: Wait for Installation', text: 'The process usually takes under a minute' },
			{ title: 'Step 5: Open and Setup', text: 'Launch the app and verify your phone number' },
		],
		after: ['You can also restore chats if you have a backup from WhatsApp.'],
	},
	{
		title: 'How to Update GB WhatsApp Pro',
		paragraphs: ['Updating GB WhatsApp Pro is important to keep the app secure and stable.'],
		subtitle: 'To update:',
		list: [
			'Download the latest APK version',
			'Install it over the existing app (no need to uninstall)',
			'Open the app and confirm update completion',
		],
		after: ['Regular updates help improve performance and reduce ban risks.'],
	},
	{
		title: 'GB WhatsApp Pro',
		titleAccent: 'vs Official WhatsApp',
		paragraphs: ['GB WhatsApp Pro and official WhatsApp serve the same purpose but differ in functionality.'],
		subtitle: 'Feature Comparison Table',
		compare: {
			columns: ['Features', 'GB WhatsApp Pro', 'Official WhatsApp'],
			rows: [
				{
					feature: 'Availability',
					gb: { text: 'Download via APK only', type: 'warn' },
					official: { text: 'Available on Google Play Store', type: 'yes' },
				},
				{
					feature: 'Security',
					gb: { text: 'Moderate (depends on source version)', type: 'warn' },
					official: { text: 'Strong end-to-end encryption', type: 'yes' },
				},
				{
					feature: 'Customization',
					gb: { text: 'Highly customizable themes & UI', type: 'yes' },
					official: { text: 'Very limited', type: 'no' },
				},
				{
					feature: 'Privacy Controls',
					gb: { text: 'Advanced privacy (hide status, ticks, typing)', type: 'yes' },
					official: { text: 'Basic privacy settings', type: 'no' },
				},
				{
					feature: 'Media Sharing',
					gb: { text: 'Larger files, higher quality sharing', type: 'yes' },
					official: { text: 'Standard file size limits', type: 'no' },
				},
				{
					feature: 'Multiple Accounts',
					gb: { text: 'Supported on same device', type: 'yes' },
					official: { text: 'Not supported (single app only)', type: 'no' },
				},
				{
					feature: 'Auto Reply',
					gb: { text: 'Available', type: 'yes' },
					official: { text: 'Not available', type: 'no' },
				},
				{
					feature: 'Anti-Delete Messages',
					gb: { text: 'Can view deleted messages', type: 'yes' },
					official: { text: 'Not available', type: 'no' },
				},
				{
					feature: 'App Support',
					gb: { text: 'Unofficial third-party app', type: 'block' },
					official: { text: 'Official and stable', type: 'yes' },
				},
			],
		},
		compareSummary: [
			{
				title: 'Official WhatsApp:',
				items: [
					'Available on Play Store',
					'Strong security and encryption',
					'Limited customization',
				],
			},
			{
				title: 'GB WhatsApp Pro:',
				items: [
					'More customization options',
					'Advanced privacy controls',
					'Extra features like auto-reply and dual accounts',
					'Not officially supported',
				],
			},
		],
		after: ['If you prefer stability and security, official WhatsApp is better. If you want features and flexibility, GB WhatsApp Pro offers more options.'],
	},
	{
		title: 'How to Use Two Accounts in GB WhatsApp Pro',
		paragraphs: ['One of the most popular features is dual account support.'],
		subtitle: 'You can:',
		list: [
			'Run two WhatsApp accounts on one device',
			'Separate personal and work chats',
			'Switch accounts easily within the app',
		],
		after: ['This feature is especially useful for users managing multiple communication needs.'],
	},
	{
		title: 'Anti-Ban Feature Works (Reality Check)',
		paragraphs: [
			'GB WhatsApp Pro claims to include an anti-ban system designed to reduce the risk of account restrictions. This system works by modifying how the app communicates with WhatsApp servers to avoid detection patterns.',
			'However, it is important to understand that no third-party WhatsApp mod can guarantee 100% safety. The anti-ban feature only reduces risk but does not eliminate it completely.',
		],
		subtitle: 'Users should always:',
		list: [
			'Avoid using outdated versions',
			'Download from trusted sources',
			'Use moderation when applying advanced features',
		],
	},
	{
		title: 'Is GB WhatsApp Pro Safe to Use?',
		paragraphs: ['GB WhatsApp Pro is generally safe if downloaded from a trusted source, but it is not officially verified by WhatsApp.'],
		subtitle: 'Risks include:',
		list: [
			'Potential account restriction',
			'Security vulnerabilities in modified apps',
			'Data privacy concerns',
		],
		after: ['Users should always be cautious and avoid sharing sensitive information through modded apps.'],
	},
	{
		title: 'Can GB WhatsApp Pro Get You Banned?',
		paragraphs: ['Yes, there is always a risk of being banned when using modified WhatsApp versions.', 'However, most users do not get banned immediately. The risk depends on:'],
		list: [
			'App version quality',
			'Usage behavior',
			'Frequency of feature abuse',
		],
		after: ['Using the latest version and avoiding suspicious activity reduces the risk significantly.'],
	},
	{
		title: 'Common Problems and Fixes',
		paragraphs: ['Some users may face issues such as crashes, installation errors, or login problems.'],
		subtitle: 'Common fixes:',
		list: [
			'Clear app cache',
			'Reinstall latest APK version',
			'Ensure internet connection is stable',
			'Update to newest version',
		],
		after: ['Most issues are resolved by simply updating the app.'],
	},
	{
		title: 'Pros and Cons of GB WhatsApp Pro',
		twoColumnsLayout: 'pills',
		twoColumns: [
			{
				title: 'Pros:',
				items: [
					'Advanced privacy features',
					'High customization',
					'Dual accounts support',
					'Extra messaging tools',
				],
			},
			{
				title: 'Cons:',
				items: [
					'Not available on Play Store',
					'Possible security risks',
					'Risk of account ban',
					'Manual updates required',
				],
			},
		],
	},
	{
		title: 'Frequently Asked Questions (FAQ)',
		faqs: [
			{ q: 'Do I need to uninstall official WhatsApp before installing GB WhatsApp Pro?', a: "No, you don't need to uninstall official WhatsApp. However, both apps must use different phone numbers if installed on the same device to avoid conflicts." },
			{ q: 'Can I restore WhatsApp chat backup in GB WhatsApp Pro?', a: 'Yes, GB WhatsApp Pro allows you to restore local WhatsApp backups during setup, as long as the backup file is stored on your device.' },
			{ q: 'Why is GB WhatsApp Pro not working or crashing?', a: 'This usually happens due to outdated versions, corrupted APK files, or compatibility issues. Updating to the latest version or reinstalling often fixes the problem.' },
			{ q: 'Does GB WhatsApp Pro require root access?', a: 'No, GB WhatsApp Pro does not require root access. It can be installed and used on any standard Android device.' },
			{ q: 'Can I change themes in GB WhatsApp Pro without downloading extra apps?', a: 'Yes, GB WhatsApp Pro has a built-in theme store where you can apply and change themes directly without third-party tools.' },
			{ q: 'Will my contacts know I am using GB WhatsApp Pro?', a: 'No, your contacts cannot directly see whether you are using GB WhatsApp Pro. However, advanced users may detect differences based on features.' },
			{ q: 'Why am I not receiving messages on GB WhatsApp Pro?', a: 'This can happen if background restrictions, DND mode, or battery optimization settings are enabled. Adjusting these settings usually resolves the issue.' },
			{ q: 'Can I use GB WhatsApp Pro for business purposes?', a: 'Yes, some users use it for small business communication due to auto-reply and multiple account features, but it is not an official business tool.' },
			{ q: 'Does GB WhatsApp Pro consume more battery than normal WhatsApp?', a: 'In some cases, yes. Because it includes extra features and background processes, it may consume slightly more battery depending on usage.' },
			{ q: 'How often should I update GB WhatsApp Pro?', a: 'It is recommended to update whenever a new version is released to improve stability, security, and compatibility with WhatsApp servers.' },
		],
	},
	{
		title: 'Final Recommendation',
		paragraphs: [
			'GB WhatsApp Pro is a powerful alternative messaging app for users who want more control, privacy, and customization than the official WhatsApp provides.',
			'However, it is important to understand the risks involved, especially regarding security and account safety. If you decide to use it, always download the latest version from a trusted source and avoid outdated APK files.',
			'For users who prioritize stability and official support, WhatsApp Messenger remains the safest choice. You can also review related [GB WhatsApp](https://gb-wave.com/) resources before deciding which app experience fits your needs.',
		],
		ctaBanner: {
			title: 'Download GB WhatsApp Pro Latest Version Now!',
			text: 'Get more features, more privacy and more control.',
			button: 'Download APK Now',
			meta: `${apkMeta.version} | ${apkMeta.size} | Updated: ${apkMeta.updated}`,
		},
	},
]

const pageSections = {
	download: [
		{
			title: 'Installation Guide',
			stepsLayout: 'timeline',
			steps: [
				{ title: 'Step 1 — Download File', text: 'Click the download button above to get the APK file.' },
				{ title: 'Step 2 — Enable Installation', text: 'Go to your device settings and allow installation from unknown sources.' },
				{ title: 'Step 3 — Install APK', text: 'Open the downloaded file and follow the on-screen instructions.' },
				{ title: 'Step 4 — Finish Setup', text: 'Wait for installation to complete and open the app from your home screen.' },
			],
		},
		{
			title: 'File Information',
			listLayout: 'file-specs',
			list: [
				`Version: ${apkMeta.version}`,
				`File Size: ${apkMeta.size}`,
				'Android Requirement: Android 5.0 or above',
				'Type: APK Installation File',
				`Last Updated: ${apkMeta.updated}`,
			],
		},
		{
			title: 'Important Note',
			variant: 'warning',
			paragraphs: [
				'This is a manually installed APK file. Please ensure you download from a trusted source and check your device settings before installation.',
			],
			visual: 'download-safety',
		},
	],
	pc: [
		{
			title: 'Why Install GB WhatsApp Pro on PC?',
			paragraphs: ['Running the application on a computer offers several practical advantages.'],
			list: [
				'Larger screen for reading long conversations',
				'Faster typing with a physical keyboard',
				'Easier drag-and-drop file sharing',
				'Better multitasking while working or studying',
				'Convenient management of photos, videos, and documents',
			],
			after: ['For many users, using a PC improves productivity without changing their daily messaging habits.'],
		},
		{ 
			title: 'System Requirements',
			table: {
				headers: ['Item', 'Recommended'],
				rows: [
					['Operating System', 'Windows 10 or Windows 11'],
					['Processor', 'Intel or AMD Dual Core'],
					['Memory', '4 GB RAM or above'],
					['Storage', '500 MB free space'],
					['Emulator', 'Android Emulator'],
					['Internet', 'Stable connection'],
				],
			},
			after: ['Most modern desktop and laptop computers can meet these requirements without additional hardware upgrades.'],
		},
		{
			title: 'Installation Guide',
			paragraphs: ['Installing GB WhatsApp Pro on a PC requires an Android emulator because there is no native Windows version.'],
			stepsLayout: 'timeline',
			steps: [
				{ title: 'Step 1 — Download APK', text: 'Download the latest APK file and save it on your computer.' },
				{ title: 'Step 2 — Install Emulator', text: 'Install an Android emulator and complete its initial setup.' },
				{ title: 'Step 3 — Import APK', text: 'Open the emulator and import the downloaded APK file.' },
				{ title: 'Step 4 — Launch App', text: 'Wait for the installation to finish and launch the application.' },
				{ title: 'Step 5 — Verify Account', text: 'Complete the account verification process and restore your chat history if you have an existing backup.' },
			],
			after: ['The overall process is very similar to installing an Android application on a mobile device.'],
		},
		{
			title: 'Performance Tips',
			paragraphs: ['For smoother performance, consider the following recommendations.'],
			list: [
				'Allocate at least 4 GB RAM to the emulator.',
				'Enable hardware virtualization in BIOS if supported.',
				'Close unnecessary background programs.',
				'Keep enough free storage space available.',
				'Update the emulator regularly.',
			],
			after: ['These simple adjustments can significantly improve startup speed and overall responsiveness.'],
		},
		{
			title: 'Common Installation Problems',
			faqs: [
				{ q: 'Emulator Will Not Start', a: 'Restart the computer and verify that virtualization is enabled.' },
				{ q: 'APK Cannot Be Installed', a: 'Download the latest package again, as incomplete downloads may cause installation errors.' },
				{ q: 'Verification Issues', a: 'Check your internet connection and confirm that your phone number can receive verification messages.' },
				{ q: 'Slow Performance', a: 'Reduce the emulator resolution or allocate additional system memory.' },
			],
		},
		{
			title: 'PC vs Mobile Experience',
			table: {
				headers: ['Feature', 'PC', 'Android Phone'],
				rows: [
					['Screen Size', 'Large', 'Compact'],
					['Keyboard', 'Physical', 'Touch'],
					['File Management', 'Easier', 'Standard'],
					['Multitasking', 'Excellent', 'Limited'],
					['Portability', 'Low', 'High'],
				],
			},
			after: ['Both platforms provide a similar messaging experience, but the desktop version is generally more comfortable for extended use.'],
		},
		{
			title: 'Which Version Should You Download?',
			paragraphs: [
				'If your computer meets modern hardware requirements, using the latest release is recommended for improved compatibility and stability.',
				'However, users with older computers or legacy Android emulators may achieve better performance with a previous APK release. In that case, visit the [GB WhatsApp Pro Old Version](/gb-whatsapp-pro-old-version/) page to compare available versions and Android requirements.',
				'Users who primarily use Apple devices should also read the [GB WhatsApp Pro for iPhone](/gb-whatsapp-pro-for-ios/) guide to understand current installation options and compatibility limitations.',
			],
		},
		{
			title: 'Frequently Asked Questions',
			faqs: [
				{ q: 'Can I install GB WhatsApp Pro directly on Windows?', a: 'No. An Android emulator is required because there is currently no native Windows edition.' },
				{ q: 'Can I use the same account on both my phone and PC?', a: 'Many users successfully use the same account after completing verification, but device switching behavior may vary depending on the application version.' },
				{ q: 'Does it work on Windows 11?', a: 'Yes. Most Android emulators support Windows 11 and provide a similar installation process.' },
				{ q: 'Should I download the latest version or an older release?', a: 'The latest version is generally recommended for newer systems, while older releases may be more suitable for legacy hardware or compatibility testing.' },
			],
		},
		{
			title: 'Final Thoughts',
			paragraphs: [
				'Using GB WhatsApp Pro on a PC provides a comfortable desktop messaging experience with a larger display and easier keyboard input. Installation is straightforward when using a compatible Android emulator, making it a practical option for users who spend most of their time on a computer.',
				'If you need the newest Android package, visit the Download page. If you are using an Apple device, explore the iPhone guide. For legacy devices and compatibility testing, the Old Version page provides additional download options and version history.',
			],
		},
	],
	ios: [
		{
			title: 'Understanding GB WhatsApp Pro on iPhone',
			paragraphs: [
				'Many users search for GB WhatsApp Pro for iPhone because they are looking for additional messaging flexibility or switching from Android devices. However, iOS works differently from Android, and this directly affects how third-party applications can be installed.',
				'Apple uses a closed system designed to control app distribution and maintain device security. Because of this, most modified applications cannot be installed in the same way as they are on Android devices.',
			],
		},
		{
			title: 'iOS Installation Reality',
			paragraphs: ['Unlike Android, iPhone does not support direct APK installation. Applications must go through the App Store or be installed using special signing methods, which are often limited or temporary.', 'This means installation availability can vary depending on:'],
			list: ['iOS version', 'Device model', 'Certificate availability', 'External installation services'],
			after: ['Because of these limitations, installation methods may not always remain stable or permanent.'],
		},
		{
			title: 'Why iPhone Installation Is Different',
			paragraphs: ["Apple's ecosystem is built around security and controlled distribution. This creates several key restrictions:"],
			list: ['No direct APK or external file installation', 'Strict App Store policies', 'Limited access to system-level modifications', 'Frequent revocation of unofficial certificates'],
			after: ['As a result, installation methods for modified applications on iOS are often less consistent compared to Android.'],
		},
		{
			title: 'Device Compatibility Overview',
			table: {
				headers: ['Device Type', 'Compatibility'],
				rows: [
					['iPhone', 'Limited / depends on method'],
					['iPad', 'Similar restrictions'],
					['Latest iOS versions', 'More restricted'],
					['Older iOS versions', 'May have temporary options'],
				],
			},
			after: ['Compatibility is not fixed and may change based on system updates.'],
		},
		{
			title: 'What Users Usually Do',
			paragraphs: ['Since direct installation is limited, users often choose alternative approaches:'],
			stepsLayout: 'timeline',
			steps: [
				{ title: 'Option 1 — Use Android Device', text: 'The simplest method is to install the application on an Android phone using the latest APK version available on the [Download page](/download/).' },
				{ title: 'Option 2 — Use PC Emulator', text: 'Some users run the application on Windows using an emulator. The full setup process is explained in the [GB WhatsApp Pro for PC](/gb-whatsapp-pro-for-pc/) section.' },
				{ title: 'Option 3 — Try Older Versions', text: 'In some cases, older versions may work better with certain environments. These can be found in the [GB WhatsApp Pro Old Version](/gb-whatsapp-pro-old-version/) page.' },
			],
		},
		{
			title: 'iPhone vs Android Installation',
			table: {
				headers: ['Feature', 'iPhone', 'Android'],
				rows: [
					['Direct APK Install', 'Not supported', 'Supported'],
					['Installation Flexibility', 'Limited', 'High'],
					['App Control', 'Restricted', 'Open system'],
					['Update Access', 'Controlled', 'Manual / flexible'],
				],
			},
			after: ['This difference is the main reason most installation tutorials focus on Android devices.'],
		},
		{
			title: 'Important Notes Before Installation',
			paragraphs: ['Before attempting any installation method, users should consider the following:'],
			list: ['Always back up important data', 'Check device compatibility', 'Verify installation source carefully', 'Understand that availability may change over time'],
			after: ['These steps help reduce potential issues during installation attempts.'],
		},
		{
			title: 'Alternatives for iOS Users',
			paragraphs: ['If installation is not possible on your device, you still have options:'],
			list: ['Use the Android version on another device', 'Run the application on a PC using an emulator', 'Continue using official messaging applications on iOS'],
			after: ['Each option depends on your device preference and usage needs.'],
		},
		{
			subtitle: 'For full installation options, you can explore:',
			linkList: [
				{ text: 'Download GB WhatsApp Pro APK for Android', href: '/download/' },
				{ text: 'GB WhatsApp Pro for PC', href: '/gb-whatsapp-pro-for-pc/' },
			],
		},
		{
			title: 'Frequently Asked Questions',
			faqs: [
				{ q: 'Can I install GB WhatsApp Pro directly on iPhone?', a: 'No direct installation method exists like Android APK files.' },
				{ q: 'Does it work on all iPhones?', a: 'Compatibility depends on iOS version and available installation methods.' },
				{ q: 'Is Android easier for installation?', a: 'Yes. Android supports direct APK installation, making the process simpler.' },
				{ q: 'What is the best alternative for iPhone users?', a: 'Most users either switch to Android, use a PC emulator, or rely on official apps.' },
			],
		},
		{
			title: 'Final Thoughts',
			paragraphs: [
				'GB WhatsApp Pro for iPhone is a frequently searched topic, but iOS limitations make installation different compared to Android. The system restrictions, security policies, and certificate dependencies all affect availability.',
				'For users looking for a simpler experience, Android installation via the latest APK is the most direct option. PC installation is also possible through emulators, while older versions may help in specific compatibility cases.',
				'To explore more options, you can visit the Download page, PC guide, or Old Version section depending on your device.',
			],
		},
	],
	old: [
		{
			title: 'When Should You Use an Older Version?',
			paragraphs: ['Older versions are not always necessary, but they can be useful in certain situations:'],
			list: [
				'Your device is running low on storage or memory',
				'The latest version is not compatible with your Android system',
				'You prefer a simpler or more familiar interface',
				'You are testing different app versions for stability',
				'A new update causes performance issues on your device',
			],
			after: ['In these cases, rolling back to a previous version may improve usability.'],
		},
		{
			title: 'Available Version Overview',
			paragraphs: ['Below is a sample list of commonly used older builds:'],
			table: {
				headers: ['Version', 'Size', 'Android Requirement'],
				rows: [
					['v17.60', '77 MB', 'Android 5.0+'],
					['v17.20', '75 MB', 'Android 5.0+'],
					['v16.90', '74 MB', 'Android 5.0+'],
					['v16.50', '72 MB', 'Android 5.0+'],
				],
			},
			after: ['Each version may differ slightly in performance, interface, and system compatibility.'],
		},
		{
			title: 'How to Install Older Versions',
			paragraphs: ['Installing an older version is similar to installing the latest APK, but there are a few important steps to follow:'],
			stepsLayout: 'timeline',
			steps: [
				{ title: 'Step 1 — Remove Existing Version', text: 'If you already have a newer version installed, uninstall it first to avoid conflicts.' },
				{ title: 'Step 2 — Download the Selected Version', text: 'Choose the version that matches your device compatibility and download the APK file.' },
				{ title: 'Step 3 — Enable Unknown Sources', text: 'Go to your device settings and allow installation from unknown sources.' },
				{ title: 'Step 4 — Install the APK', text: 'Open the downloaded file and follow the installation instructions.' },
				{ title: 'Step 5 — Complete Setup', text: 'Launch the application and complete the verification process if required.' },
			],
		},
		{
			title: 'Old Version vs Latest Version',
			table: {
				headers: ['Feature', 'Old Version', 'Latest Version'],
				rows: [
					['Performance', 'Stable on older devices', 'Optimized for new devices'],
					['Features', 'Limited', 'Updated features'],
					['Compatibility', 'High for legacy phones', 'Requires newer Android'],
					['Updates', 'No new updates', 'Regular updates'],
				],
			},
			after: ['Choosing between old and new versions depends on your device capability and personal preference.'],
		},
		{
			title: 'Compatibility Considerations',
			paragraphs: ['Older versions generally work better on:'],
			list: ['Low RAM Android devices', 'Older Android operating systems', 'Devices with limited storage', 'Users who prefer lightweight applications'],
			after: ['However, they may not include the latest improvements or fixes.'],
		},
		{
			title: 'Common Issues with Old Versions',
			faqs: [
				{ q: 'App Not Installing', a: 'Make sure the previous version is fully removed before installing.' },
				{ q: 'Login Problems', a: 'Some older versions may require re-verification after installation.' },
				{ q: 'Feature Differences', a: 'Certain features may not be available compared to newer releases.' },
				{ q: 'Performance Lag', a: 'Try switching to a slightly newer version if performance is unstable.' },
			],
		},
		{
			title: 'Why Users Prefer Older Versions',
			paragraphs: ['Despite newer updates, many users still choose older builds because:'],
			list: ['They are more stable on specific devices', 'Interface feels more familiar', 'Lower system resource usage', 'Fewer frequent changes'],
			after: ['This makes older versions a practical choice for long-term use on limited hardware.'],
		},
		{
			title: 'Alternative Pages You May Need',
			paragraphs: ['Depending on your device, you may also want to explore:'],
			linkList: [
				{ text: 'Download GB WhatsApp Pro APK', href: '/download/', note: 'for the latest Android version' },
				{ text: 'GB WhatsApp Pro for PC', href: '/gb-whatsapp-pro-for-pc/', note: 'for Windows installation using emulator' },
				{ text: 'GB WhatsApp Pro for iOS', href: '/gb-whatsapp-pro-for-ios/', note: 'for Apple device compatibility information' },
			],
			after: ['These pages help you choose the right version based on your platform.'],
		},
		{
			title: 'Frequently Asked Questions',
			faqs: [
				{ q: 'Are old versions safe to use?', a: 'They can be used for compatibility purposes, but users should always verify the source before downloading.' },
				{ q: 'Can I update from an old version?', a: 'Yes, you can install a newer version later after uninstalling the old one.' },
				{ q: 'Which old version is most stable?', a: 'Stability depends on your device. Mid-range versions often provide the best balance.' },
				{ q: 'Do old versions still work?', a: 'Yes, most older versions still function, but they may lack newer improvements.' },
			],
		},
		{
			title: 'Final Thoughts',
			paragraphs: [
				'GB WhatsApp Pro Old Version pages are useful for users who want better compatibility or prefer earlier builds of the application. While the latest version is recommended for most users, older releases remain an important option for devices with limited performance or specific requirements.',
				'If your device supports it, the latest download page is the best choice. For desktop usage, you can check the PC installation guide, and for Apple users, the iOS page provides compatibility details.',
				'Choosing the right version depends on your device capability, performance needs, and personal preference.',
			],
		},
	],
}

const legalSections = {
	privacy: [
		{ paragraphs: ['This Privacy Policy explains how gbwhatspro.chat handles information collected through this website. By using our website, you agree to the practices described in this policy.'] },
		{ title: 'Information We Collect', paragraphs: ['We may collect limited information such as:'], list: ['Browser type', 'Device information', 'Operating system', 'Pages visited', 'Referral source', 'Anonymous analytics data'], after: ['We do not intentionally collect sensitive personal information unless you voluntarily provide it through our contact form.'] },
		{ title: 'Cookies', paragraphs: ['This website may use cookies to improve user experience, remember preferences, and analyze website performance.', 'Users can disable cookies through their browser settings at any time.'] },
		{ title: 'Third-Party Services', paragraphs: ['We may use third-party analytics or advertising services that collect anonymous usage data according to their own privacy policies.'] },
		{ title: 'External Links', paragraphs: ['Our website may contain links to external websites. We are not responsible for the privacy practices or content of those websites.'] },
		{ title: 'Data Security', paragraphs: ['We take reasonable measures to protect information but cannot guarantee absolute security during internet transmission.'] },
		{ title: 'Policy Updates', paragraphs: ['This Privacy Policy may be updated without prior notice. Users are encouraged to review this page periodically.'] },
	],
	terms: [
		{ paragraphs: ['By accessing this website, you agree to comply with these Terms & Conditions.'] },
		{ title: 'Website Content', paragraphs: ['All information is provided for informational purposes only and may be updated or removed at any time without notice.'] },
		{ title: 'User Responsibilities', paragraphs: ['Users agree to:'], list: ['Use the website lawfully', 'Verify downloaded files independently', 'Follow applicable local regulations', 'Accept responsibility for installation decisions'] },
		{ title: 'Intellectual Property', paragraphs: ['All original website content, including text, design, and graphics, belongs to gbwhatspro.chat unless otherwise stated.'] },
		{ title: 'External Resources', paragraphs: ['Links to third-party websites are provided for convenience only. We do not control or endorse external content.'] },
		{ title: 'Limitation of Liability', paragraphs: ['gbwhatspro.chat shall not be liable for any damages resulting from the use of this website or downloaded resources.'] },
		{ title: 'Changes', paragraphs: ['These Terms & Conditions may be updated at any time without prior notice.'] },
	],
	disclaimer: [
		{ title: 'General Information', paragraphs: ['All information published on gbwhatspro.chat is provided for general informational and educational purposes only.'] },
		{ title: 'No Warranty', paragraphs: ['We make no guarantees regarding the completeness, accuracy, or reliability of any information presented.'] },
		{ title: 'Third-Party Files', paragraphs: ['Some resources referenced on this website may originate from third-party providers. We do not control or guarantee those resources.'] },
		{ title: 'User Responsibility', paragraphs: ['Users should verify compatibility, source authenticity, and installation requirements before downloading or installing any file.'] },
		{ title: 'No Official Affiliation', paragraphs: ['gbwhatspro.chat is an independent informational website and is not affiliated with WhatsApp, Meta, or any official messaging platform.'] },
		{ title: 'Liability', paragraphs: ["Use of this website and its information is entirely at the user's own risk."] },
	],
	contact: [
		{ title: "We're Here to Help", paragraphs: ['If you have questions about this website, its content, or general inquiries, feel free to contact us.'] },
		{ title: 'You Can Reach Us For', list: ['Website feedback', 'Content corrections', 'Technical issues', 'Partnership inquiries', 'General questions'] },
		{ contactForm: true },
		{ title: 'Response Time', paragraphs: ['We aim to respond to most inquiries within 2–5 business days.'] },
		{ title: 'Important Notice', paragraphs: ['Please do not include sensitive personal information in your message.'] },
	],
}

export const pages = {
	home: {
		key: 'home',
		path: '/',
		meta: makeMeta(
			'GB WhatsApp Pro APK Download V18.80 (Official) Latest Version 2026',
			'Download GB WhatsApp Pro APK latest version 2026 with installation guide, features, and safety tips. Learn how to install and update GB WhatsApp Pro safely on Android.',
			'GB WhatsApp, GB WhatsApp Pro APK download',
			'/'
		),
		hero: {
			variant: 'home',
			eyebrow: 'Latest Version 2026',
			titleLines: [
				{ text: 'GB WhatsApp Pro', tone: 'main' },
				{ text: 'Download ', accent: 'Latest Version', tone: 'sub' },
			],
			lines: ['Privacy Features, Custom Themes, Dual Accounts & More.'],
			badges: ['Safe Download', 'No Root Required', 'Android 5.0+'],
			primary: 'Download APK',
			secondary: 'Installation Guide',
			secondaryAnchor: 'how-to-install-gb-whatsapp-pro-on-android',
			image: heroIcon,
			imageAlt: 'GB WhatsApp Pro 3D app icon',
			card: [
				{ label: 'Version', value: apkMeta.version, icon: 'version' },
				{ label: 'Android', value: '5.0 and above', icon: 'android' },
				{ label: 'Size', value: apkMeta.size, icon: 'size' },
			],
		},
		sections: homeSections,
	},
	download: {
		key: 'download',
		path: '/download/',
		meta: makeMeta(
			'Download GB WhatsApp Pro APK | Secure APK Access',
			'Get the latest version and follow a simple installation process on your Android device. After downloading the file, enable installation from unknown sources and complete the setup in a few steps.',
			'gb whatsapp pro download',
			'/download/'
		),
		hero: {
			variant: 'apk-download',
			titleLines: [
				{ text: 'Download GB WhatsApp Pro ', accent: 'APK', tone: 'main' },
			],
			lines: [`Latest version ${apkMeta.version} • ${apkMeta.size} • ${apkMeta.android} • Easy installation APK.`],
			badges: ['Safe Download', 'No Root Required', apkMeta.android],
			primary: 'Download APK',
			secondary: 'Installation Guide',
			secondaryAnchor: 'installation-guide',
			sidePanel: {
				label: 'APK',
				title: 'Quick Android setup',
				text: 'Download, allow installation, then open the app.',
				items: [
					{ label: 'Get APK', icon: 'download' },
					{ label: 'Allow install', icon: 'android' },
					{ label: 'Follow guide', icon: 'guide' },
				],
			},
		},
		sections: pageSections.download,
	},
	pc: {
		key: 'pc',
		path: '/gb-whatsapp-pro-for-pc/',
		meta: makeMeta(
			'GB WhatsApp Pro for PC | Download & Windows 9,10,11',
			'Download GB WhatsApp Pro for PC and install it on Windows 9, 10, or 11 using an Android emulator. Follow the setup guide, check system requirements, and get started in minutes.',
			'GB WhatsApp Pro for PC',
			'/gb-whatsapp-pro-for-pc/'
		),
		hero: {
			variant: 'simple',
			title: 'Download GB WhatsApp Pro for PC | Windows 9,10,11',
			lines: [
				'Many users prefer chatting on a computer instead of a mobile phone. A larger display, physical keyboard, and easier file management make the desktop experience more convenient for both personal and professional communication.',
				'Although GB WhatsApp Pro is designed for Android devices, it can also run on Windows by using a compatible Android emulator. The installation process is straightforward and only requires a few minutes.',
			],
			primary: 'Download GB WhatsApp Pro for PC',
		},
		sections: pageSections.pc,
	},
	ios: {
		key: 'ios',
		path: '/gb-whatsapp-pro-for-ios/',
		meta: makeMeta(
			'GB WhatsApp Pro for iPhone | iOS',
			'GB WhatsApp Pro for iPhone iOS compatibility, installation limitations, and alternative options for Apple devices.',
			'GB WhatsApp Pro for iPhone',
			'/gb-whatsapp-pro-for-ios/'
		),
		hero: {
			variant: 'simple',
			title: 'GB WhatsApp Pro for iPhone | iOS',
			primary: 'Download APK for Android',
		},
		sections: pageSections.ios,
	},
	old: {
		key: 'old',
		path: '/gb-whatsapp-pro-old-version/',
		meta: makeMeta(
			'GB WhatsApp Pro Old Version | Download Previous APK Releases',
			'Download GB WhatsApp Pro old versions for compatibility and stability. Browse previous APK releases, check version details, and install on Android devices easily.',
			'gb whatsapp pro old version',
			'/gb-whatsapp-pro-old-version/'
		),
		hero: {
			variant: 'simple',
			title: 'GB WhatsApp Pro Old Version | Download Previous APK Releases',
			lines: [
				'Many users search for older versions of [GB WhatsApp Pro](/) when the latest release does not work properly on their device or when they prefer a more stable experience. In some cases, newer updates may require higher system resources, which can affect performance on older Android phones.',
				'Older versions are often used for compatibility, stability, or personal preference. They provide a way for users to continue using the application without upgrading their device.',
			],
			primary: 'Download GB WhatsApp Pro Latest Version',
		},
		sections: pageSections.old,
	},
	privacy: {
		key: 'privacy',
		path: '/privacy-policy/',
		meta: makeMeta('Privacy Policy', 'Learn how gbwhatspro.chat collects, uses, and protects information when you browse the website, download files, or contact us.', 'privacy policy', '/privacy-policy/'),
		hero: { title: 'Privacy Policy', variant: 'legal' },
		sections: legalSections.privacy,
	},
	terms: {
		key: 'terms',
		path: '/terms-and-conditions/',
		meta: makeMeta('Terms & Conditions', 'Read the terms and conditions governing the use of gbwhatspro.chat, including website access, content usage, and user responsibilities.', 'terms and conditions', '/terms-and-conditions/'),
		hero: { title: 'Terms & Conditions', variant: 'legal' },
		sections: legalSections.terms,
	},
	disclaimer: {
		key: 'disclaimer',
		path: '/disclaimer/',
		meta: makeMeta('Disclaimer', 'Read the disclaimer for gbwhatspro.chat regarding website content, downloadable resources, third-party links, and user responsibilities.', 'disclaimer', '/disclaimer/'),
		hero: { title: 'Disclaimer', variant: 'legal' },
		sections: legalSections.disclaimer,
	},
	contact: {
		key: 'contact',
		path: '/contact/',
		meta: makeMeta('Contact Us', 'Get in touch with the gbwhatspro.chat team for general questions, feedback, or website-related inquiries.', 'contact us', '/contact/'),
		hero: { title: 'Contact Us', variant: 'legal' },
		sections: legalSections.contact,
	},
}

export const pageList = Object.values(pages)
export const siteLogo = logo
